// unavailableIds: choice IDs that are currently unavailable (e.g. day-parted out).
// When provided, the prefill logic skips unavailable choices so we don't persist
// an unavailable default into choiceSelections.
export default function choiceSelectionsFromBase(
  choiceSets: ChoiceSet[],
  keyProperty: 'key' | 'id' = 'key',
  stockBalanceDataMap?: SDict<StockBalanceData>,
  unavailableIds?: Set<string>,
): ChoiceSelections {
  const result: ChoiceSelections = {};

  const preSelect = (c: Choice): string[] => {
    if (unavailableIds?.has(c.id)) return [];

    const baseQty = c.baseQuantity || 0;

    if (stockBalanceDataMap && c.plucode in stockBalanceDataMap) {
      const adjustedBalance =
        stockBalanceDataMap[c.plucode].cartAdjustedBalance || 0;

      if (adjustedBalance >= c.baseQuantity) {
        return Array(baseQty).fill(c.id);
      } else {
        return [];
      }
    }

    return Array(baseQty).fill(c.id);
  };

  choiceSets.forEach(choiceSet => {
    let selections: string[] = [];
    choiceSet.choices.forEach(choice => {
      selections = [...selections, ...preSelect(choice)];
    });

    result[choiceSet[keyProperty]] = selections;
  });

  return result;
}
